import { useQuery } from "@tanstack/react-query";

import { axiosInstance } from "../lib/axios";

export type AskneoServiceBackend = {
  id: string;
  name: string;
};

type AskneoServicesResponse = {
  backends: AskneoServiceBackend[];
  default: string;
};

export const ASKNEO_SERVICE_STORAGE_KEY = "askneoService";

const ASKNEO_SERVICES_QUERY_KEY = ["askneo-services"] as const;

const fetchAskneoServices = async () => {
  return axiosInstance.get<AskneoServicesResponse>("/chat/services");
};

export const useFetchAskneoServices = (enabled: boolean) => {
  return useQuery({
    queryKey: ASKNEO_SERVICES_QUERY_KEY,
    queryFn: fetchAskneoServices,
    select: (data) => data.data,
    enabled,
    staleTime: Infinity,
  });
};
